/* eslint-disable @typescript-eslint/camelcase */
import { CardApiClient } from './cardApiClient';
import * as platformClient from './platformClient';
var managerUsers = {
    getManagerUsers: '/v1/managers',
    saveManagerUsers: function (id) { return "/v1/managers/" + id; }
};
/* eslint-disable @typescript-eslint/no-explicit-any */
function toManagerUsersFormated(data) {
    return data.managers.map(function (mu) {
        return ({
            id: mu.id,
            first_name: mu.first_name,
            last_name: mu.last_name,
            email: mu.email,
            account_administrator: mu.account_administrator,
            shops: mu.shops.map(function (shop) { return ({ name: shop.name, id: shop.id }); }),
            validated_account: mu.validated_account
        });
    });
}
/* eslint-enable @typescript-eslint/no-explicit-any */
export function getManagerUsers() {
    return CardApiClient.get(managerUsers.getManagerUsers).then(function (response) {
        return toManagerUsersFormated(response.data);
    });
}
export function saveManagerUser(managerUser) {
    var managerUserToBody = {
        email: managerUser.email,
        first_name: managerUser.first_name,
        last_name: managerUser.last_name,
        account_administrator: managerUser.account_administrator,
        shop_ids: managerUser.shops.map(function (shop) { return shop.id; })
    };
    return CardApiClient.patch(managerUsers.saveManagerUsers(managerUser.id), managerUserToBody);
}
export function resendInvitation(id) {
    return platformClient.resendInvitation(id);
}
